export const MAIN_CLASS_NAME = 'ib-search';

export const CONTROL_CLASS_NAME = `${MAIN_CLASS_NAME}__control`;
export const WINDOW_CLASS_NAME = `${CONTROL_CLASS_NAME}__window`;
export const CONTENT_CLASS_NAME = `${WINDOW_CLASS_NAME}__content`;
export const INPUT_CLASS_NAME = `${CONTENT_CLASS_NAME}__input`;
export const CLEAR_BUTTON_CLASS_NAME = `${CONTROL_CLASS_NAME}__clear-button`;
